import { PureComponent } from 'react'
import * as styles from 'styles/molecules/forms/OnboardingForm.css'
import GatherHeader from 'components/features/pfm/GatherHeader/GatherHeader'
import Onboarding from 'components/pages/Onboarding'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import RegisterForm from 'components/molecules/forms/RegisterForm'
import Anchor from 'components/atoms/navigation/Anchor'
import { ONBOARDING_REGISTER } from 'constants/pages'
import { ENFORCE_POLICY_AGREEMENT, ONBOARDING_STEP_NUMBERS, STEPS_COUNT_WITH_FORM } from 'constants/onboarding'
import LoginLink from 'components/atoms/LoginLink'
import { RouteProps } from 'react-router'
import { PageMeta } from 'components/features/pfm/PageMeta/PageMeta'

const STEP_NUMBER = ONBOARDING_STEP_NUMBERS['register']

class OnboardingRegister extends PureComponent<RouteProps> {
  render () {
    const { location } = this.props
    const search = location ? location.search : undefined

    return (
      <Anchor placement={ ONBOARDING_REGISTER }>
        <PageMeta
          title='Join for Free'
          description='Earn $5 for joining'
        />
        <Onboarding progressPercent={ 33 }>
          <GatherHeader
            title='Hello, let’s create your account'
            step={ STEP_NUMBER }
            maxStep={ STEPS_COUNT_WITH_FORM }
          >
            You'll earn a $5 reward for creating your Status account.
          </GatherHeader>
          <section className={ styles.onboardingFormWrapper }>
            <RegisterForm />
          </section>
          { this.renderTermsInvitation() }
          <div className={ styles.loginInvitation }>
            Already registered?
            Please <LoginLink search={ search }>login</LoginLink>.
          </div>
        </Onboarding>
      </Anchor>
    )
  }

  renderTermsInvitation () {
    return !ENFORCE_POLICY_AGREEMENT
      ? (
        <div className={ styles.termsInvitation }>
          By creating an account, you agree to the Status<br />
          <NavigationLink to='terms'>
            <span className={ styles.link }>Terms &amp; Conditions</span>
          </NavigationLink>
          <span> and </span>
          <NavigationLink to='privacy'>
            <span className={ styles.link }>Privacy Policy</span>
          </NavigationLink>.
        </div>
      ) : null
  }
}

export default OnboardingRegister
